import { render, staticRenderFns } from "./V2PhoneInput.vue?vue&type=template&id=b8b629d8&scoped=true&"
import script from "./V2PhoneInput.vue?vue&type=script&lang=js&"
export * from "./V2PhoneInput.vue?vue&type=script&lang=js&"
import style0 from "./V2PhoneInput.vue?vue&type=style&index=0&id=b8b629d8&lang=scss&scoped=true&"
import style1 from "./V2PhoneInput.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b629d8",
  null
  
)

export default component.exports